import React from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, List, ModalHeader, Typography, UtpCardModal } from 'common/components';

const servicesModalText = css`
  margin-bottom: 8px;
`;

const servicesModalList = css`
  && {
    li {
      margin-bottom: 0;
    }
  }
`;

export const Services: React.FC<UtpCardModal> = ({ elementBlock = '', onClick }) => (
  <>
    <ModalHeader title="Сделаем всё под ключ" />
    <ModalContent>
      <Typography className={servicesModalText} variant="m" size="body_long">
        Наш специалист сделает замер и&nbsp;расчёт кровли на&nbsp;вашем объекте, составит точную смету
        и&nbsp;проконсультирует по&nbsp;всем вопросам. А&nbsp;опытная бригада от&nbsp;наших партнёров
        выполнит монтаж и&nbsp;учтёт все особенности объекта.
      </Typography>
      <Typography variant="m" size="body_long">
        Сделаем профессионально:
      </Typography>
      <List className={cn(servicesModalText, servicesModalList)} listStyle="disc">
        <li>
          <Typography variant="m" size="body_long">
            замеры
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            демонтаж старой кровли
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            утепление и&nbsp;гидроизоляция
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            монтаж новой кровли
          </Typography>
        </li>
      </List>

      <Typography color="text-secondary" variant="m" size="body_long">
        Доступность услуг можно уточнить онлайн или в&nbsp;магазине.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={elementBlock}
        elementName="Записаться на консультацию"
        elementText="Услуги Лемана ПРО"
        onClick={onClick}
        wide>
        Записаться на консультацию
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
